export const isDev = process.env.REACT_APP_NODE_ENV === 'dev-v2'
export const isProd = process.env.REACT_APP_NODE_ENV === 'prod-v2'
export const isQa = process.env.REACT_APP_NODE_ENV === 'qa-v2'
export const isTest = process.env.REACT_APP_NODE_ENV === 'test'
